__webpack_require__.p = "https://assets.jiffy.com/packs/";